<template>
  <div>
    <div v-if="!is_shuffle && !is_neko && !is_licorice">
      <div class="videoletter-empty">
        <img src="/static/img/common/video_letter_empty.svg" class="u-mg-t-6" alt="no_image_box">
        <p class="videoletter-empty__message u-mg-t-3" v-if="!is_digi">ただいま撮影中です</p>
        <p class="videoletter-empty__message u-mg-t-3" v-if="is_digi">ただいま制作中です</p>
        <div class="order_waiting_message">
          <p>{{getFormattedOrderLimit(this.$attrs["data-order-limit"])}} までにお届けします</p>
          <p>お届け後、動画はここに表示されます</p>
        </div>
      </div>
    </div>
    <div v-if="is_shuffle">
      <div class="metal">
        <img src="/static/img/metal/shuffle.jpg" alt class="metal__image">
        <img
          :src="`${awsPrefix}/digi_videoletter/movie/${itemId}/shuffle/${tarot}.png`"
          alt
          class="metal__tarot"
        >
        <p class="metal__date">
          動画が完成したら
          <br>
          <span>{{getFormattedOrderLimit(this.$attrs["data-order-limit"])}}</span>までに
          <br>登録済みのメールアドレスに連絡するぜ！楽しみにしててくれー！
        </p>
        <!--
        <ul class="metal__share">
          <li class="metal__share__list">
            <a
              href="http://twitter.com/share?url=https://uranai.tv/movie/fast/7/detail/050007?cpno=990000000070&text=🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥%0a🃏+%23ヘヴィメタルタロット+🃏%0a🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥%0a史上初!?  ＼  ヘヴィメタル × 占い  ／%0a占い芸人の橋山メイデンが魂込めて占うぜぇぇぇ🤘%0a激しさMAXにつき取扱い注意💜😂%0a"
              target="_blank"
              class="-twitter"
              @click="sendGatag('twitter_metal_shuffle')"
            >
              <img src="/static/img/metal/twitter.png" alt>
            </a>
          </li>
          <li class="metal__share__list">
            <a
              href="http://line.me/R/msg/text/?🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥%0a🃏+%23ヘヴィメタルタロット 🃏%0a 🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥%0a史上初!?   ＼  ヘヴィメタル × 占い  ／%0a占い芸人の橋山メイデンが魂込めて占うぜぇぇぇ🤘%0a激しさMAXにつき取扱い注意💜😂%0ahttps://uranai.tv/movie/fast/7/detail/050007?cpno=990000000072"
              target="_blank"
              class="-line"
              @click="sendGatag('line_metal_shuffle')"
            >
              <img src="/static/img/metal/line.png" alt>
            </a>
          </li>
          <li class="metal__share__list">
            <a
              href="http://www.facebook.com/share.php?u=https://uranai.tv/movie/fast/7/detail/050007?cpno=990000000074"
              target="_blank"
              class="-facebook"
              @click="sendGatag('facebook_metal_shuffle')"
            >
              <img src="/static/img/metal/facebook.png" alt>
            </a>
          </li>
        </ul>
        -->
        <movie-modal
          :movie-url="`${awsPrefix}/digi_videoletter/movie/${itemId}/shuffle/${tarot}.mp4`"
          :is-show-button="true"
        ></movie-modal>
        <p class="metal__attention">
          【注意事項】
          <br>・占いビデオレターのお届けなど、お客様へのお知らせは、help@uranai.tvまたは、info@uranai.tvよりお送りします。受信設定のご確認をお願いします。
          <br>・お申し込み後の内容変更や払い戻しは承っておりません。
        </p>
      </div>
    </div>
    <div v-if="is_neko">
      <div class="neko">
        <p class="neko__date">{{getFormattedOrderLimit(this.$attrs["data-order-limit"])}}までにお届けします</p>
        <p class="neko__attention">
          【注意事項】
          <br>・占いビデオレターのお届けなど、お客様へのお知らせは、help@uranai.tvまたは、info@uranai.tvよりお送りします。受信設定のご確認をお願いします。
          <br>・お申し込み後の内容変更や払い戻しは承っておりません。
        </p>
        <!--
        <div class="neko__share">
          <p class="neko__share__heading">マタタビ～不思議な猫のタロット占い～<br>を友達にシェアしよう</p>
          <div class="neko__share__link">
            <a href="http://twitter.com/share?url=https://uranai.tv/movie/fast/9/detail/050009?cpno=990000000079&text=・° .＊🃏🃏🃏🃏🃏🃏🃏＊.°・ %0aマタタビ～ %23不思議な猫のタロット占い ～%0a%0a何百年も生きているとか%0a魔法が使えるとか…%0a不思議な猫の占い師%0a%0aあなたの迷いにカードで答えを🌟%0a進むべき道を照らします🍁%0a%0a👇猫の占い師に会いに行く%0a" target="_blank" class="neko__share__link__list" onclick="gtag('event', 'click', {'event_category': 'result_share', 'event_label': 'twitter_neko_before'})"><img src="/static/img/neko/twitter.png" alt=""></a>
            <a href="http://line.me/R/msg/text/?・° .＊🃏🃏🃏🃏🃏🃏🃏＊.°・ %0aマタタビ～不思議な猫のタロット占い～%0a%0a何百年も生きているとか%0a魔法が使えるとか…%0a不思議な猫の占い師%0a%0aあなたの迷いにカードで答えを🌟%0a進むべき道を照らします🍁%0a%0a👇猫の占い師に会いに行く%0ahttps://uranai.tv/movie/fast/9/detail/050009?cpno=990000000082" target="_blank" class="neko__share__link__list" onclick="gtag('event', 'click', {'event_category': 'result_share', 'event_label': 'line_neko_before'})"><img src="/static/img/neko/line.png" alt=""></a>
            <a href="http://www.facebook.com/share.php?u=https://uranai.tv/movie/fast/9/detail/050009?cpno=990000000085" target="_blank" class="neko__share__link__list" onclick="gtag('event', 'click', {'event_category': 'result_share', 'event_label': 'facebook_neko_before'})"><img src="/static/img/neko/facebook.png" alt=""></a>
          </div>
        </div>
        -->
      </div>
    </div>
    <div v-if="is_licorice" class="licorice">
      <div class="licorice__main">
        <span class="wait-message">もうしばらくお待ちください</span>
        <p class="arrival-datetime">{{getFormattedOrderLimit(this.$attrs["data-order-limit"])}}までにご連絡いたします。</p>
      </div>
      <p class="licorice__attention">
        【注意事項】
        <br>・占いビデオレターのお届けなど、お客様へのお知らせは、help@uranai.tvまたは、info@uranai.tvよりお送りします。受信設定のご確認をお願いします。
        <br>・お申し込み後の内容変更や払い戻しは承っておりません。
      </p>
      <!--
      <sns-licorice
        :sharedata="{
          twitter: {
            text: textTwitter,
            galabel: 'twitter_licorice_before'
          },
          line: {
            text: textLine,
            galabel: 'line_licorice_before'
          },
          facebook: {
            galabel: 'facebook_licorice_before'
          }
        }"
      ></sns-licorice>
      -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'videoletter-empty',
  props: {
    is_digi: { type: Number, default: 0 },
    is_shuffle: { type: Number, default: 0 },
    is_neko: { type: Number, default: 0 },
    is_licorice: { type: Number, default: 0 },
    itemId: { type: Number, default: 0 },
    tarot: { type: Number, default: 0 },
    awsPrefix: { type: String, defualt: '' },
    textTwitter: { type: String, default: '' },
    textLine: { type: String, default: '' }
  },
  methods: {
    getFormattedOrderLimit(date) {
      return moment(date).format('YYYY/MM/DD(ddd) 23:59');
    },
    sendGatag(rabel) {
      window.gtag('event', 'click', {
        event_category: 'result_share',
        event_label: rabel
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../sass/functions/breakpoint.scss';
@import '../../../sass/variables/index';

.order_waiting_message {
  background: #fef5f9;
  border: 1px solid #f2d0df;
  box-sizing: border-box;
  border-radius: 4px;
  color: #ed1e79;
  padding: 16px 12px;
  p {
    margin: 0 auto;
  }
}
.metal {
  position: relative;
  width: calc(100% + 32px);
  margin: 0 -16px;
  border-top: 4px solid black;
  &__image {
    display: block;
    width: 100%;
    height: auto;
  }
  &__tarot {
    display: block;
    position: absolute;
    top: 217px;
    left: 141px;
    width: 298px;
    height: auto;
    @include breakpoint(mobileonly) {
      top: 37vw;
      left: 24.5vw;
      width: 51vw;
    }
  }
  &__date {
    position: absolute;
    top: 64px;
    left: 30px;
    width: 330px;
    line-height: 1.38;
    margin: 0;
    font-size: 20px;
    font-weight: bold;
    color: white;
    @include breakpoint(mobileonly) {
      top: 11vw;
      left: 5vw;
      width: 57.5vw;
      font-size: 3.5vw;
    }
    span {
      color: #fffb76;
    }
  }
  &__share {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    position: relative;
    margin: -62px 0 0;
    padding: 243px 32px 24px;
    list-style: none;
    background-image: url('/static/img/metal/tosns_share.png');
    background-size: 100% auto;
    @include breakpoint(mobileonly) {
      margin: -11.7vw 0 0;
      padding: 42vw 32px 5vw;
    }
    &__list {
      a {
        display: block;
      }
      img {
        display: block;
        width: 100%;
      }
      &:nth-of-type(n + 2) {
        width: calc(50% - 6px);
        margin-top: 12px;
      }
    }
  }
  &__attention {
    line-height: 1.66;
    margin: 40px 12px 0;
    padding: 24px 0;
    font-size: 12px;
    color: #676767;
    border-top: 1px solid #ededed;
    border-bottom: 1px solid #ededed;
  }
  &__prod {
    border-top: 1px solid #ccc;
    border-bottom: none;
    padding: 8px 0 0;
  }
  &__thumbnail {
    border-radius: 6px;
  }
}
.neko {
  margin: 0 -16px 0;
  padding-top: 671px;
  background: black;
  background-image: url('/static/img/neko/wait.png');
  background-repeat: no-repeat;
  background-size: 100% auto;
  @include breakpoint(mobileonly) {
    padding-top: 115.7vw;
  }
  &__date {
    margin: 0;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    color: white;
    @include breakpoint(mobileonly) {
      font-size: 3.5vw;
    }
  }
  &__attention {
    line-height: 1.66;
    margin: 87px 12px 0;
    font-size: 18px;
    color: white;
    padding-bottom: 30px;
    @include breakpoint(mobileonly) {
      margin-top: 15vw;
      font-size: 3.2vw;
    }
  }
  &__share {
    position: relative;
    margin-top: 46px;
    padding: 46px 32px 62px;
    background-image: url('/static/img/neko/complete_share.png');
    background-repeat: no-repeat;
    background-size: 100% auto;
    @include breakpoint(mobileonly) {
      margin-top: 8vw;
      padding: 8vw 32px 10.7vw;
    }
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 46px;
      background-image: url('/static/img/neko/border.png');
      background-repeat: no-repeat;
      background-position: center center;
      background-size: auto 100%;
      transform: translate(0, -60%);
      @include breakpoint(mobileonly) {
        height: 8vw;
      }
    }
    &__heading {
      line-height: 2;
      margin: 0;
      font-size: 23px;
      font-weight: bold;
      text-align: center;
      color: white;
      @include breakpoint(mobileonly) {
        font-size: 4vw;
      }
    }
    &__link {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      margin-top: 28px;
      @include breakpoint(mobileonly) {
        margin-top: 4.8vw;
      }
      &__list {
        display: block;
        width: calc(50% - 6px);
        margin-top: 12px;
        border-radius: 4px;
        box-shadow: 0px 4px 2px rgba(black, 0.35);
        &:first-child {
          width: 100%;
          margin-top: 0;
        }
        img {
          display: block;
          width: 100%;
        }
      }
    }
  }
}
.licorice {
  margin: 0 -16px -20px;
  width: 580px;
  @include breakpoint(mobileonly) {
    width: 100vw;
  }
  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 7px;
    background: $gray-light;
  }
  &__main {
    width: 100%;
    padding-top: 464px;
    padding-bottom: 22px;
    background: url('/static/img/licorice/detail/bg_tsukishiro.png') no-repeat center top #1D110A;
    background-size: 100% auto;
    color: $brown-9;
    @include breakpoint(mobileonly) {
      padding-top: 80vw;
    }
    .wait-message {
      width: 100%;
      display: block;
      font-family: $font_mincho;
      text-align: center;
      font-size: 19px;
      line-height: 23px;
      margin-bottom: 32px;
      padding-top: 12px;
    }
    .arrival-datetime {
      width: calc(100% - 22px - 22px);
      height: 64px;
      background: $brown-4;
      border: 1px solid $brown-5;
      border-radius: 5px;
      margin: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      font-size: 12px;
      font-family: $font_mincho;
      line-height: 1;
    }
  }
  &__attention {
    width: 100%;
    color: $brown-4;
    background: $brown-7;
    padding: 24px 12px;
    font-size: 12px;
    line-height: 20px;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/VideoletterEmpty.vue